<template>
  <v-app>
    <v-toolbar hover>
      <v-toolbar-side-icon style="color: white" @click.stop="drawer = !drawer" color="orange"></v-toolbar-side-icon>
      <v-toolbar-title>
        <v-layout row align-center>
          <span style="color:orange;">{{header}}</span>
          <v-card v-if="status" class="mx-4" color="orange">
            <VueCountdown v-if="duration" :time="duration" emit-events @end="submit">
              <div class="mx-2" slot-scope="props" style="color: white"> {{ props.hours }} : {{ props.minutes }} : {{props.seconds}} </div>
            </VueCountdown>
          </v-card>
        </v-layout>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>

        <!-- <v-tooltip bottom color="orange"> -->
          <!-- <template v-slot:activator="{on}"> -->
            <!-- <v-btn to="/exam" v-on="on" flat> -->
              <!-- <v-icon color="orange">home</v-icon> -->
            <!-- </v-btn> -->
          <!-- </template> -->
          <!-- <span style="color: white">Homepage</span> -->
        <!-- </v-tooltip> -->
        
        <v-tooltip bottom color="orange">
          <template v-slot:activator="{on}">
            <v-btn to="/about" v-on="on" flat>
              <v-icon color="orange">info</v-icon>
            </v-btn>
          </template>
          <span style="color: white">About</span>
        </v-tooltip>

        <v-tooltip bottom color="orange">
          <template v-slot:activator="{on}">
            <v-btn @click="signout" v-on="on" flat>
              <v-icon color="orange">meeting_room</v-icon>
            </v-btn>
          </template>
          <span style="color: white">Sign Out</span>
        </v-tooltip>

      </v-toolbar-items>
    </v-toolbar>
    <v-navigation-drawer
      v-model="drawer"
      :mini-variant="mini"
      style="color:orange;"
      absolute
      temporary
    >
      <v-list class="pa-1">
        <v-list-tile v-if="mini" @click.stop="mini = !mini">
          <v-list-tile-action>
            <v-icon>chevron_right</v-icon>
          </v-list-tile-action>
        </v-list-tile>
        <v-list-tile avatar tag="div">
          <v-list-tile-avatar>
            <v-avatar v-if="userPhoto">
              <v-dialog max-width="500px">
                <template v-slot:activator="{ on }">
                  <img :src="userPhoto" v-on="on" />
                </template>
                <v-card hover>
                  <v-container grid-list-md>
                    <v-layout row>
                      <v-flex xs12 sm6 md4 reverse>
                        <v-img :src="userPhoto"></v-img>
                      </v-flex>
                      <v-layout column justify-center align-center>
                        <h1>
                          <v-icon>arrow_drop_down</v-icon>Photo URL
                          <v-icon>arrow_drop_down</v-icon>
                        </h1>
                        <h3>{{userPhoto}}</h3>
                        <h5>[ Size : 200x300 px ]</h5>
                      </v-layout>
                    </v-layout>
                  </v-container>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="orange" flat @click="drawer = !drawer">Close</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-avatar>
            <v-avatar v-else>
              <v-icon>person</v-icon>
            </v-avatar> 
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-text-field v-model="name" :value="name" color="orange" disabled></v-text-field>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-btn icon @click.stop="mini = !mini">
              <v-icon>chevron_left</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
      <v-list class="pt-0" dense>
        <v-divider light></v-divider>
        <v-list-tile>
          <v-list-tile-action>
            <v-icon color="orange">lock</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-dialog max-width="500px">
              <template v-slot:activator="{ on }">
                <v-list-tile-title v-on="on" style="color:orange">Change Password</v-list-tile-title>
              </template>
              <v-card hover>
                <v-card-title>
                  <span class="headline">Change {{ name }} Password</span>
                </v-card-title>
                <v-container grid-list-md>
                  <v-layout wrap column>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        type="password"
                        label="Current Password"
                        v-model="password.old"
                        color="orange"
                      ></v-text-field>
                      <v-text-field
                        type="password"
                        label="New Password"
                        v-model="password.new"
                        color="orange"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="orange" flat @click="chgpw">Change</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-action>
            <v-icon color="orange">photo_library</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-dialog max-width="500px">
              <template v-slot:activator="{ on }">
                <v-list-tile-title v-on="on" style="color:orange">Photo Profile</v-list-tile-title>
              </template>
              <v-card hover>
                <v-card-title>
                  <span class="headline">Pick Preferred Image</span>
                </v-card-title>
                <v-container grid-list-md>
                  <v-layout wrap column>
                    <v-flex xs12 sm6 md4>
                      <v-avatar v-for="(p,i) in photos" :key="i">
                        <img :src="p" @click="chgphoto(p)" />
                      </v-avatar>
                    </v-flex>
                  </v-layout>
                </v-container>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="orange" flat @click="drawer = !drawer">Close</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-dialog color="orange" width="500px" persistent v-model="warning">
      <v-card color="orange">
        <v-layout column justify-center align-center>
          <v-card-title class="headline" style="color: white">Warning , progress will be submitted !</v-card-title>
          <v-card-actions>
            <v-layout row>
              <v-btn @click="warning = false" round color="white"><div style="color: orange">Cancel</div></v-btn>
              <div class="mx-2"></div>
              <v-btn @click="submit" color="white" round><div style="color: orange">Proceed</div></v-btn>
            </v-layout>
          </v-card-actions>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-expansion-panel>
      <v-expansion-panel-content v-for="(i,no) in Quiz" :key="no">
        <template v-slot:header>
          <div style="color: orange"> 🔥 No. {{no + 1}}</div>
        </template>
        <v-card hover>
          <v-layout column align-center><h3>{{i.text}}</h3></v-layout>
          <v-radio-group v-model="opt[no]" column class="mx-4">
            <v-radio :label="i.a" color="orange" value="a"></v-radio>
            <v-radio :label="i.b" color="orange" value="b"></v-radio>
            <v-radio :label="i.c" color="orange" value="c"></v-radio>
            <v-radio :label="i.d" color="orange" value="d"></v-radio>
          </v-radio-group>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-layout justify-center>
      <v-btn color="orange" @click="submit" v-model="loading" round :loading="loading">
        <span style="color: white">Submit Answer ✔️</span>
      </v-btn>
    </v-layout>
    
  </v-app>
</template>

<script>
import firebase from "firebase";
import router from "@/router";
import VueCountdown from '@chenfengyuan/vue-countdown'

const _db = firebase.firestore();
const _auth = firebase.auth();

export default {
  components: {
    VueCountdown,
  },
  data() {
    return {
      status: null,
      duration: null,
      userPhoto: "",
      photos: [],
      icon: "",
      mini: false,
      password: { new: "", old: "" },
      drawer: null,
      name: "",
      Quiz: [],
      opt: [],
      score: 0,
      uid: "",
      temp: "",
      loading: false,
      warning: false,
      redirect: false
    };
  },
  computed: {
    header() {
      return localStorage.getItem("type") == "pretest"
        ? "Pre-Test" + " " + localStorage.getItem("name")
        : "Post-Test" + " " + localStorage.getItem("name");
    }
  },
  beforeMount() {
    window.addEventListener("beforeunload", this.preventNav)
    this.$once("hook:beforeDestroy", () => {
      window.removeEventListener("beforeunload", this.preventNav);
    })
  },
  beforeRouteLeave(to, from, next) {
    if(this.redirect) next();
    this.warning = true
  },
  methods: {
    preventNav(event) {
      if (this.warning) return
      event.preventDefault()
      event.returnValue = ""
    },

    chgphoto: function(v) {
      this.userPhoto = v;
      _auth.currentUser.updateProfile({ photoURL: v }).catch(er => {
        alert(er);
      });
    },
    chgpw: function() {
      _auth.currentUser
        .reauthenticateWithCredential(
          firebase.auth.EmailAuthProvider.credential(
            _auth.currentUser.email,
            this.password.old
          )
        )
        .then(
          _auth.currentUser
            .updatePassword(this.password.new)
            .then(e => alert("password updated succesfully ", e))
            .catch(r => alert(r))
        );
    },
    signout: function() {
      firebase
        .auth()
        .signOut()
        .then(function() {
          router.push("/");
        });
    }, 
    submit: function() {
      this.redirect = true
      this.score = 0;
      for (var i = 0; i <= this.opt.length - 1; i++) {
        if (this.opt[i] == this.Quiz[i].answer) this.score += 10;
      }
      var data = {
        username: _auth.currentUser.displayName,
        photo: _auth.currentUser.photoURL,
        type: localStorage.getItem("name")
      };
      if (localStorage.getItem("type") == "posttest") {
        _db
          .collection("scores")
          .where("uid", "==", this.uid)
          .get()
          .then(s => {
            this.temp = s.docs.map(m => {
              return m.data();
            });
            if ((this.temp[0].pretest + this.score) / 2 < 60) {
              data.status = "Not Good";
              data.posttest = this.score;
            } else {
              data.status = "Good";
              data.posttest = this.score;
            }
            _db
              .collection("scores")
              .doc(this.temp[0].id)
              .update(data)
              .then(() => {
                localStorage.clear("name");
                localStorage.clear("type");
                router.push("/score");
              })
              .catch(r => {
                alert(r);
                localStorage.clear("name");
                localStorage.clear("type");
                router.push("/");
              });
          })
          .catch(r => {
            alert(r);
            localStorage.clear("name");
            localStorage.clear("type");
            router.push("/");
          });
      } else {
        this.score < 60 ? (data.status = "Not Good") : (data.status = "Good"),
          (data.pretest = this.score);
        _db
          .collection("scores")
          .add(data)
          .catch(e => {
            alert(e);
            localStorage.clear("name");
            localStorage.clear("type");
            router.push("/");
          })
          .then(t => {
            t.update({
              id: t.id,
              uid: this.uid,
              date: new Date().toISOString().substring(0, 10)
            });
            localStorage.clear("name");
            localStorage.clear("type");
            router.push("/score");
          })
          .catch(r => {
            alert(r);
            localStorage.clear("name");
            localStorage.clear("type");
            router.push("/");
          });
      }
      this.loading = !this.loading;
    }
  },
  mounted() {
    this.name = _auth.currentUser.displayName;
    this.userPhoto = _auth.currentUser.photoURL;
    this.uid = _auth.currentUser.uid;
    for (let i = 0; i <= 107; i++) {
      const rand = Math.floor(Math.random() * 999);
      this.photos.push("https://picsum.photos/id/" + rand + "/200/300");
    }
  },
  beforeCreate() {
    const db = localStorage.getItem("name");
    const type = localStorage.getItem("type");
    if (!db || !type) router.push("/exam");
    _db.collection("modules").doc(db).get().then((doc)=>{
      var type = localStorage.getItem("type")
      this.status = doc.data().duration['status']
      var timeParts
      switch(type){
        case 'pretest':
          timeParts = doc.data().duration['pre-test'].split(":")
          this.duration = (+timeParts[0] * (60000 * 60)) + (+timeParts[1] * 60000)
        break
        case 'posttest':
          timeParts = doc.data().duration['post-test'].split(":")
          this.duration = (+timeParts[0] * (60000 * 60)) + (+timeParts[1] * 60000)
        break
      }
    })
    this.Quiz = _db
      .collection("modules")
      .doc(db)
      .collection("questions")
      .where(type, "==", true)
      .onSnapshot(querySnapshot => {
        var q = querySnapshot.docs.map(docSnap => {
          return docSnap.data();
        });
        this.Quiz = q;
      });
  }
};
</script>
